module.exports = __webpack_public_path__ + "img/Rahul.1a6b2030.jpeg";